import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./Components/Header/Header";

import FirstSection from "./Components/FirstSection/FirstSection";
import SecondSection from "./Components/SecondSection/SecondSection";
import ThirdSection from "./Components/ThirdSection/ThirdSection";
import FourthSection from "./Components/FourthSection/FourthSection";

import Footer from "./Components/Footer/Footer";

import StaffProfile from "./Components/Footer/StaffProfile/StaffProfile";

/* IMPORT ABOUT PAGE */

import About from "./Components/About/About";

/* IMPORT SERVICES PAGE */

import Services from "./Components/Services/Services";

/* IMPORT FOUNDER PAGE */

import Founder from "./Components/Founder/Founder";

/* IMPORT PROJECTS PAGE */

import Projects from "./Components/Projects/Projects";

/* IMPORT GALLERY PAGE */

import Gallery from "./Components/Gallery/Gallery";

/* IMPORT CONTACT PAGE */

import Contact from "./Components/Contact/Contact";

/* HOME PAGE */

function HomePage() {

  return (
    <>
      <Header />

      <FirstSection />
      <SecondSection />
      <ThirdSection />
      <FourthSection />

      <Footer />
    </>
  );
}

/* ABOUT PAGE */

function AboutPage() {

  return (
    <>
      <Header />

      <About />

      <Footer />
    </>
  );
}

/* SERVICES PAGE */

function ServicesPage() {

  return (
    <>
      <Header />

      <Services />

      <Footer />
    </>
  );
}

/* FOUNDER PAGE */

function FounderPage() {

  return (
    <>
      <Header />

      <Founder />

      <Footer />
    </>
  );
}

/* PROJECTS PAGE */

function ProjectsPage() {

  return (
    <>
      <Header />

      <Projects />

      <Footer />
    </>
  );
}

/* GALLERY PAGE */

function GalleryPage() {

  return (
    <>
      <Header />

      <Gallery />

      <Footer />
    </>
  );
}

/* CONTACT PAGE */

function ContactPage() {

  return (
    <>
      <Header />

      <Contact />

      <Footer />
    </>
  );
}

function App() {

  return (

    <BrowserRouter>

      <Routes>

        {/* HOME PAGE */}

        <Route
          path="/"
          element={<HomePage />}
        />

        {/* ABOUT PAGE */}

        <Route
          path="/about"
          element={<AboutPage />}
        />

        {/* SERVICES PAGE */}

        <Route
          path="/services"
          element={<ServicesPage />}
        />

        {/* FOUNDER PAGE */}

        <Route
          path="/founder"
          element={<FounderPage />}
        />

        {/* PROJECTS PAGE */}

        <Route
          path="/projects"
          element={<ProjectsPage />}
        />

        {/* GALLERY PAGE */}

        <Route
          path="/gallery"
          element={<GalleryPage />}
        />

        {/* CONTACT PAGE */}

        <Route
          path="/contact"
          element={<ContactPage />}
        />

        {/* STAFF PROFILE */}

        <Route
          path="/staffProfile"
          element={<StaffProfile />}
        />

      </Routes>

    </BrowserRouter>
  );
}

export default App;